console.log("Starting up wordpress theme szero from Spring");
